import React, { Component } from 'react';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import DataStore from './../../../stores/DataStore'
/**
 * @class 
 * Attribut für CheckBoxen (ja, nein checkboxen)
 * Welche ein Label und eine Checkbox beinhalten
 * @name CheckBoxAttribute
 *  @implements {Attribute}
 */
class CheckBoxAttribute extends Component {

  onChange(evt) {
    const { attribute: { onChange, id } = {} } = this.props;
    onChange(!DataStore.attributeValues[id].value);
  }

  getValue() {
    return DataStore.attributeValues[this.id].value;
  }

  getValueString() {
    const { value = "noSet" } = DataStore.attributeValues[this.id];
    return value.toString();
  }

  getSummaryDisplay() {
    return (
      <div>{this.getValueString()}</div>
    )
  }

  render() {
    const {
      attribute: {
        id = '',
        name = '',
        attributeOption: {
          FormCtrlLabel = FormControlLabel,
          CB = Checkbox,
          FormControlLabelProps = {},
          CheckBoxProps = {}
        },
        attributeModul,
      } = {}
    } = this.props;
    this.id = id;
    attributeModul.holdedAttribute = this;
    return (
      <FormCtrlLabel
        control={
          <CB
            disabled={DataStore.attributeValues[this.id].readOnly}
            checked={DataStore.attributeValues[id].value}
            onChange={evt => this.onChange(evt)}
            name={name}
            {...CheckBoxProps}
          />
        }
        label={name}
        {...FormControlLabelProps}

      />
    );
  }
}

export default CheckBoxAttribute;
